import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import useSuperpartner from '../../../hooks/useSuperpartner';
import { ROLES } from '../../../model/roles';
import { Spinner } from 'react-bootstrap';

function CreateAgenziaForm({formCreateAgenzia, setFormCreateAgenzia, showModalCreateAgenzia}) {

    const userLoggedIn = useSelector(state => state?.user?.userData);
    const { getAllSuperpartner, loadingStateSuperpartner } = useSuperpartner();
    const [superpartnerList, setSuperpartnerList] = useState([]);
    const [isEnabledShippingForm, setIsEnabledShippingForm] = useState(false);

    useEffect(() => {
        if(!showModalCreateAgenzia) {
            setFormCreateAgenzia({});
            setIsEnabledShippingForm(false);
        } else {
            const hasShipping = !!(
                formCreateAgenzia?.spedizione_nominativo ||
                formCreateAgenzia?.spedizione_indirizzo ||
                formCreateAgenzia?.spedizione_cap ||
                formCreateAgenzia?.spedizione_citta ||
                formCreateAgenzia?.spedizione_provincia
            );
            setIsEnabledShippingForm(hasShipping);
            if (userLoggedIn?.role === ROLES.ADMIN || userLoggedIn?.role === ROLES.DEVELOPER) {
                fetchSuperpartnerList();
            }
        }
    }, [showModalCreateAgenzia]);

    const fetchSuperpartnerList = async () => {
        const response = await getAllSuperpartner();
        setSuperpartnerList(response ?? []);
    };

    const handleFormChange = e => {
        const { name, value } = e.target;
        setFormCreateAgenzia(prevState => ({ ...prevState, [name]: value }));
    };

    const handleCheckboxShippingChange = () => {
        const next = !isEnabledShippingForm;
        setIsEnabledShippingForm(next);
        if (!next) {
            setFormCreateAgenzia(prev => ({
                ...prev,
                spedizione_nominativo: '',
                spedizione_indirizzo: '',
                spedizione_cap: '',
                spedizione_citta: '',
                spedizione_provincia: '',
            }));
        }
    };

    // --- NUOVA FUNZIONE PER IL RENDER DEL MENU A TENDINA ---
    const renderSuperpartnerSelect = () => {
        // Mostra questo campo solo se l'utente loggato è un Admin o Developer
        if (userLoggedIn?.role === ROLES.ADMIN || userLoggedIn?.role === ROLES.DEVELOPER) {
            return (
                <div className='col-12 my-2'>
                    <span className='small text-muted d-block mb-1'><b>Associa a Superpartner (opzionale)</b></span>
                    {loadingStateSuperpartner.isLoadingSuperpartner ? (
                        <div className="text-center py-3"><Spinner /></div>
                    ) : (
                        <select 
                            name="id_superpartner" 
                            className="form-control" 
                            value={formCreateAgenzia.id_superpartner || 'nessuno'} 
                            onChange={handleFormChange}
                        >
                            <option value="nessuno">Nessuno</option>
                            {superpartnerList.map(sp => (
                                <option key={sp.id_superpartner} value={sp.id_superpartner}>
                                    {sp.nome}
                                </option>
                            ))}
                        </select>
                    )}
                </div>
            );
        }
        return null; // Non mostrare nulla per gli altri ruoli (es. Superpartner)
    };

  return (
    <div className='container'>
        <div className='row'>
            <div className='col-sm-12 col-md-6 my-2'>
            <span className='small text-muted d-block mb-1'><b>Ragione sociale</b></span>
               <input name="denominazione" value={formCreateAgenzia.denominazione || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="Ragione sociale"/>
            </div>
            <div className='col-sm-12 col-md-6 my-2'>
            <span className='small text-muted d-block mb-1'><b>Indirizzo</b></span>
               <input name="indirizzo" value={formCreateAgenzia.indirizzo || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="Indirizzo"/>
            </div>
        </div>
        <div className='row'>
            <div className='col-sm-12 col-md-6 my-2'>
            <span className='small text-muted d-block mb-1'><b>CAP</b></span>
               <input name="cap" value={formCreateAgenzia.cap || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="CAP"/>
            </div>
            <div className='col-sm-12 col-md-6 my-2'>
            <span className='small text-muted d-block mb-1'><b>Città</b></span>
               <input name="citta" value={formCreateAgenzia.citta || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="Città"/>
            </div>
        </div>
        <div className='row'>
            <div className='col-sm-12 col-md-6 my-2'>
            <span className='small text-muted d-block mb-1'><b>Provincia</b></span>
               <input name="provincia" value={formCreateAgenzia.provincia || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="Provincia"/>
            </div>
            <div className='col-sm-12 col-md-6 my-2'>
            <span className='small text-muted d-block mb-1'><b>Partita iva</b></span>
               <input name="piva" value={formCreateAgenzia.piva || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="Partita iva"/>
            </div>
        </div>
        <div className='row'>
            <div className='col-sm-12 col-md-6 my-2'>
            <span className='small text-muted d-block mb-1'><b>Referente</b></span>
               <input name="referente" value={formCreateAgenzia.referente || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="Referente"/>
            </div>
            <div className='col-sm-12 col-md-6 my-2'>
            <span className='small text-muted d-block mb-1'><b>Email</b></span>
               <input name="email" value={formCreateAgenzia.email || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="Email"/>
            </div>
        </div>
        <div className='row'>
            <div className='col-12 my-2'>
            <span className='small text-muted d-block mb-1'><b>Note</b></span>
               <textarea name="note" value={formCreateAgenzia.note || ''} onChange={handleFormChange} className="form-control" rows={3} type="text" placeholder="Note"/>
            </div>
        </div>

        <div className='row mt-3'>
            <div className='col-12'>
                <span className='fs-5 d-block mb-2'><i>Dati spedizione attestati</i> <small className='text-muted'>(opzionale)</small></span>
                <div className="form-check mb-3">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        id="agenzia-indirizzo-spedizione-diverso"
                        checked={isEnabledShippingForm}
                        onChange={handleCheckboxShippingChange}
                    />
                    <label className="form-check-label" htmlFor="agenzia-indirizzo-spedizione-diverso">
                        Indirizzo di spedizione diverso dalla sede legale
                    </label>
                </div>
                {!isEnabledShippingForm && (
                    <p className="small text-muted">Se non compilato, per le spedizioni verrà usata la ragione sociale e l&apos;indirizzo della sede legale.</p>
                )}
            </div>
        </div>
        {isEnabledShippingForm && (
            <>
                <div className='row'>
                    <div className='col-sm-12 col-md-6 my-2'>
                        <span className='small text-muted d-block mb-1'><b>Nominativo destinatario</b></span>
                        <input name="spedizione_nominativo" value={formCreateAgenzia.spedizione_nominativo || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="Può essere diverso dalla ragione sociale"/>
                    </div>
                    <div className='col-sm-12 col-md-6 my-2'>
                        <span className='small text-muted d-block mb-1'><b>Indirizzo spedizione</b></span>
                        <input name="spedizione_indirizzo" value={formCreateAgenzia.spedizione_indirizzo || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="Indirizzo"/>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-sm-12 col-md-4 my-2'>
                        <span className='small text-muted d-block mb-1'><b>CAP</b></span>
                        <input name="spedizione_cap" value={formCreateAgenzia.spedizione_cap || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="CAP"/>
                    </div>
                    <div className='col-sm-12 col-md-4 my-2'>
                        <span className='small text-muted d-block mb-1'><b>Città</b></span>
                        <input name="spedizione_citta" value={formCreateAgenzia.spedizione_citta || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="Città"/>
                    </div>
                    <div className='col-sm-12 col-md-4 my-2'>
                        <span className='small text-muted d-block mb-1'><b>Provincia</b></span>
                        <input name="spedizione_provincia" value={formCreateAgenzia.spedizione_provincia || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="Provincia" maxLength={2}/>
                    </div>
                </div>
            </>
        )}

        <div className='row'>
            {renderSuperpartnerSelect()}
        </div>
    </div>
  )
}

export default CreateAgenziaForm;